(function () {
  var DISCOUNTED_PROTECTOR_ID = 49077021671659;
  var ORIGINAL_PROTECTOR_ID = 37223548387494;
  var PILLOW_VARIANT_IDS = [49036802326763, 49036802392299];

  function getProtectorCap(cart) {
    var paidPillows = 0;
    (cart.items || []).forEach(function (item) {
      if (PILLOW_VARIANT_IDS.indexOf(item.variant_id) !== -1 && item.final_line_price > 0) {
        paidPillows += item.quantity;
      }
    });
    return Math.max(paidPillows * 2, 2);
  }

  function getDiscountedQty(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === DISCOUNTED_PROTECTOR_ID) qty += item.quantity;
    });
    return qty;
  }

  document.addEventListener('click', function (e) {
    var plusBtn = e.target.closest('.js-qty__adjust--plus');
    if (!plusBtn) return;

    var wrapper = plusBtn.closest('.js-qty__wrapper');
    if (!wrapper || wrapper.getAttribute('data-discounted-protector') !== 'true') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var input = wrapper.querySelector('.js-qty__num');
    var key = input && input.getAttribute('data-id');
    if (!key) return;

    wrapper.classList.add('is-loading');

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var discountedQty = getDiscountedQty(cart);
        var cap = getProtectorCap(cart);

        if (discountedQty < cap) {
          // still under cap → increase discounted line normally
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: discountedQty + 1 })
          }).then(function (r) { return r.json(); });
        }

        // at/above cap → add original full-price protector
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ORIGINAL_PROTECTOR_ID, quantity: 1 })
        }).then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        wrapper.classList.remove('is-loading');
      })
      .catch(function (err) {
        console.error(err);
        wrapper.classList.remove('is-loading');
      });
  }, true); // capture so it runs before theme QtySelector
})();